export const COMMUNITIES_RESET_STATE = 'COMMUNITIES_RESET_STATE';
export const COMMUNITIES_CURRENT_ITEM = 'COMMUNITIES_CURRENT_ITEM';

export const COMMUNITIES_REQUEST_LOADING = 'COMMUNITIES_REQUEST_LOADING';
export const COMMUNITIES_REQUEST_SUCCESS = 'COMMUNITIES_REQUEST_SUCCESS';
export const COMMUNITIES_REQUEST_FAILED = 'COMMUNITIES_REQUEST_FAILED';

export const COMMUNITIES_CURRENT_ACTION = 'COMMUNITIES_CURRENT_ACTION';
export const COMMUNITIES_RESET_ACTION = 'COMMUNITIES_RESET_ACTION';